<header class="header"><span>Latest locations 📍</span></header>

<style>
  .header {
    width: 100%;
    grid-column-start: 1;
    grid-column-end: 3;
    background: rgb(98, 30, 153);
    border-bottom: 1px solid black;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  @media (max-width: 900px) {
    .header {
      grid-column-start: 1;
      grid-column-end: 1;
    }
  }
</style>
